import { useApi } from 'Service/axios';
import { Button, Tooltip } from '@mui/material';
import { useState, useEffect } from 'react';
import { Box } from '@mui/system';

import EditIcon from '@mui/icons-material/Edit';
import { Receipt } from '@mui/icons-material';

const ActionButton = ({
    row,
    setTransferencia,
    resetStates,
    handleChangeLocationsOrigem,
    handleChangeLocationsDestino,
    getTransferenciaDataById
}) => {
    /////////////////////////////// FUNÇÕES /////////////////////////
    const handleOpen = async () => {
        setTransferencia({
            id: row.id,
            itemId: row.item_id,
            almoxarifado_origem: row.origemAlmoxarifado.id,
            localizacao_origem: row.origemLocalizacao.id,
            unidade: row.unidade_id,
            observacao: row.observacao,
            quantidade: row.quantidade,
            data: row.data_transferencia,
            almoxarifado_destino: row.destinoAlmoxarifado.id,
            localizacao_destino: row.destinoLocalizacao.id
        });

        handleChangeLocationsOrigem(row.origemAlmoxarifado.id);
        handleChangeLocationsDestino(row.destinoAlmoxarifado.id);
        resetStates();
    };

    return (
        <Box>
            {/* <Tooltip title="Editar Entrada">
                <Button onClick={handleOpen}>
                    <EditIcon />
                </Button>
            </Tooltip> */}
            <Tooltip title="Relatório">
                <Button onClick={() => getTransferenciaDataById(row.id)}>
                    <Receipt />
                </Button>
            </Tooltip>
        </Box>
    );
};

export default ActionButton;
